module.exports = __webpack_public_path__ + "img/bpx-mapa.33d0fb1e.png";